import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {BlockContainer, InnerBlockContainer} from "BaseComponents/Wrappers";
import {GetTextColor} from "Helpers/ColorHelper";
import styled from "styled-components";
import he from 'he'
import {useGlobal} from "reactn";

export const HtmlBlock = ({
                              Html,
                              BackgroundColor
                          }) => {
    const {textColor} = GetTextColor(BackgroundColor);
    const htmlBlockValue = useRef(null);

    if (!Html) {
        return null;
    }
    const decodeHtml = he.decode(Html);
    const [theme] = useGlobal("theme");

    useEffect(() => {
        if (htmlBlockValue?.current) {
            const scripts = htmlBlockValue.current.getElementsByTagName("script");
            if (scripts) {
                const arrayScript = [...scripts];
                arrayScript.forEach((s) => {
                    const text = s.innerHTML;
                    if (text) {
                        setTimeout(() => {
                            window.eval(text);
                        }, 10)
                    } else {
                        if (s.attributes) {
                            const script = document.createElement("script");
                            Array.from(s.attributes).forEach(({name, value}) => {
                                script.setAttribute(name, value);
                            });
                            htmlBlockValue.current.appendChild(script);
                        }
                    }
                });
            }
        }

    }, [htmlBlockValue]);

    return (
        <BlockContainer
            className="htmlBlock"
            bgColor={`#${BackgroundColor || 'fff'}`}
        >
            <InnerBlockContainer>
                <HtmlWrapper ref={htmlBlockValue} className={'htmlWrapperHtml'} color={textColor}
                             dangerouslySetInnerHTML={{__html: decodeHtml}}></HtmlWrapper>
            </InnerBlockContainer>
        </BlockContainer>
    );
};

export const HtmlWrapper = styled.div`
    color: ${({color, theme}) => (color ? `#${color}` : theme.colors.primary)};

`;

HtmlBlock.propTypes = {
    Html: PropTypes.string,
    BackgroundColor: PropTypes.string,
};
